module.exports = __webpack_public_path__ + "media/images/athletes/3337-41846621f595e17ed38f91c03c0c251d.png";